const toolTipData = [
  {
    id: "date",
    text: "Select Date."
  },
  {
    id: "locationId",
    text: "Select Location to Get the Users Attendance."
  },
  {
    id: "Filter",
    text: "Search by Title."
  }
];

const tableHeaderData = [
  {
    label: "Location Name",
    place: "left",
    type: "locationName",
    toolTipText: "Click for Location Sorting"
  },
  {
    label: "Type",
    place: "left",
    type: "queryTypeStatus",
    toolTipText: "Click for Type Sorting"
  },
  {
    label: "Status",
    place: "left",
    type: "queryStatus",
    toolTipText: "Click for Query Sorting"
  }
];

export { toolTipData, tableHeaderData };
